import React, { useCallback, useState, useEffect } from 'react';
import { Form, Button, Input, Space, Spin, Result, Alert, message } from 'antd';
import { examination } from '@/api/examinationApi';
import { useParams, history } from 'umi';
import config from '@/utils/config';

import './index.css';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 6, span: 16 },
};

/** 试卷确认页面 */
const ConfirmExamPage = () => {
  const { token_id } = useParams<{ token_id: string }>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<API.examinationVerify>();
  const [error, setError] = useState<Error>();

  const getAllData = useCallback(async (token) => {
    try {
      const res = await examination.verify({ token });
      if (res.code === 1) {
        throw new Error('链接有误，请联系 HR 重新获取笔试链接');
      }
      if (res.code === 2) {
        throw new Error('试卷尚在生成请稍后重试');
      }
      setData(res.data);
      window.Pandora.send('zijin_testee_page_view', {
        page: 'view',
        onlyid: res.data.examId,
      });
    } catch (e: any) {
      setError(new Error(e?.message ?? e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getAllData(token_id);
  }, [getAllData, token_id]);

  /** 确认 */
  const handleConfirm = () => {
    window.Pandora.send('zijin_testee_click_question', {
      onlyid: data?.examId,
    });
    const sUserAgent = window.navigator.userAgent;
    if (
      sUserAgent.indexOf('Android') > -1 ||
      sUserAgent.indexOf('iPhone') > -1 ||
      sUserAgent.indexOf('iPad') > -1 ||
      sUserAgent.indexOf('iPod') > -1 ||
      sUserAgent.indexOf('Symbian') > -1
    ) {
      message.error('请在 PC 端答题');
      return;
    }
    // alert(sUserAgent);
    if (['wechat', 'qqbrowse'].find((item) => sUserAgent.toLowerCase().includes(item))) {
      message.error('请使用 edge 或者 google 浏览器作答');
      return;
    }
    // 是否有谷歌内核
    const hasChrome = sUserAgent.match(/Chrome\/([0-9]+)/);
    if (!hasChrome || Number(hasChrome[1]) < 80) {
      message.error('请使用 edge 或者 google 浏览器作答(Google 内核版本需要大于 80)');
      return;
    }
    if (config.nodeEnv === 'production') {
      window.open(
        `/examination?exam_id=${data?.examId}&candidate_id=${data?.candidateId}`,
        '_blank',
        'fullscreen=yes,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no',
      );
    } else {
      window.open(`/examination?exam_id=${data?.examId}&candidate_id=${data?.candidateId}`);
    }
  };

  if (error)
    return (
      <div>
        <Result status="warning" title={error.message || 'error'} />
      </div>
    );
  if (loading)
    return (
      <div>
        <Spin />
      </div>
    );

  return (
    <div style={{ paddingTop: 100 }}>
      <div style={{ textAlign: 'center', marginBottom: 50 }}>
        <h2>{data?.candidateName + '的笔试题'}</h2>
      </div>
      <div className="confirm-exam-from" style={{ width: 800, margin: '0 auto' }}>
        <Form
          initialValues={{ name: data?.candidateName, email: data?.candidateEmail }}
          form={form}
          {...layout}
          colon
          autoComplete="off"
        >
          <Form.Item label="姓名" name="name">
            <Input disabled />
          </Form.Item>
          <Form.Item label="邮箱" name="email">
            <Input disabled />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Space>
              <div>请确认您的姓名和邮箱，若有问题请联系hr</div>
              <Button type="primary" onClick={handleConfirm}>
                去答题
              </Button>
            </Space>
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Alert
              message={
                <a
                  target="_blank"
                  onClick={() => {
                    window.Pandora.send('zijin_testee_click_video', {
                      page: 'view',
                      onlyid: data?.examId,
                    });
                  }}
                  href="https://cdn.233xyx.com/1638532218655_171.mp4"
                >
                  <b>教学视频</b>
                </a>
              }
              banner
            />
            <Alert message="点击 「去答题」 后将开始考试计时" banner />
            <Alert message="请使用 edge 或 google 浏览器" banner />
            <Alert message="需要摄像头权限" banner />
            <Alert message="需要屏幕录制权限" banner />
            <Alert message="切换屏幕会被记录" banner />
            <Alert message="建议答题时间：8:00 - 22:00" banner />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ConfirmExamPage;
